import { render } from "./TeamView.vue?vue&type=template&id=1a305c97&scoped=true"
import script from "./TeamView.vue?vue&type=script&lang=js"
export * from "./TeamView.vue?vue&type=script&lang=js"

import "./TeamView.vue?vue&type=style&index=0&id=1a305c97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a305c97"]])

export default __exports__